import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'

import {
  Heading2,
  FilledButton,
  Form,
  FormGroup,
  GridWrapper,
  GridItem,
  List,
  ListItem,
} from '@sainsburys-tech/luna-react'
import { TextInputField } from '@sainsburys-tech/luna-form/extensions/formik'
import capitalise from 'src/utils/capitalise'

const FormComponent = ({ handleClose, handleSubmit: onSubmit, setFieldValue }) => (
  <Form onSubmit={onSubmit}>
    <Heading2>Are you sure you want to edit this {capitalise('point of sale')}</Heading2>
    <p>Please confirm this action</p>
    <FormGroup name="shelf-fields">
      <GridWrapper matrix>
        <GridItem size="1/1" className="ln-u-hard-bottom">
          <Field
            component={TextInputField}
            data-control="description"
            label="Description"
            name="description"
            validationFirst={false}
            placeholder="Please add a description"
            autoFocus
          />
        </GridItem>
      </GridWrapper>
    </FormGroup>
    <List type="matrix">
      <ListItem type="matrix">
        <FilledButton
          data-control="Save"
          name="Save"
          value="Save"
          type="submit"
          onClick={() => {
            setFieldValue('isSubmitting', true)
          }}
        >
          Save
        </FilledButton>
      </ListItem>
      <ListItem type="matrix">
        <FilledButton color="dark" data-control="cancel" onClick={handleClose}>
          <span>Cancel</span>
        </FilledButton>
      </ListItem>
    </List>
  </Form>
)

FormComponent.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.shape({
    description: PropTypes.string,
  }),
}

FormComponent.defaultProps = {
  values: {},
}

export default FormComponent
